import React from 'react';

const ResourcesProductUpdate = () => (
  <section style={{ maxWidth: 1470, margin: '48px auto 0 auto', padding: '0 24px' }}>
    <hr style={{ border: 0, borderTop: '2px solid #cbd5e1', marginBottom: 24 }} />
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
      <span style={{ color: '#0098d0', fontWeight: 600, fontSize: 22, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        Product updates
        <svg style={{ marginLeft: 6 }} width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M7 10l5 5 5-5" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </span>
    </div>
    <h3 style={{ fontWeight: 600, fontSize: 20, marginBottom: 32, marginTop: 0 }}>&ldquo;What's New with Genix&rdquo;</h3>
    <div style={{
      background: '#0098d0',
      borderRadius: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '40px 48px',
      gap: 32,
      color: '#fff',
      flexWrap: 'wrap'
    }}>
      <div style={{ flex: 1, minWidth: 260 }}>
        <h2 style={{ fontWeight: 600, fontSize: 28, marginBottom: 16 }}>Genix Pendant</h2>
        <p style={{ fontSize: 17, marginBottom: 28, lineHeight: 1.6 }}>
          Genix Pendant is a next-generation wearable device designed to act as an AI-powered healthcare assistant.
          It transforms clinical conversations into <span style={{ fontWeight: 600, color: '#fff', textDecoration: 'underline' }}>real-time, multilingual, structured, and actionable data</span>,
          right from the moment it hears your voice.
        </p>
        <a
          href="#"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: '#fff',
            color: '#0098d0',
            fontWeight: 500,
            fontSize: 16,
            borderRadius: 12,
            padding: '14px 28px',
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            transition: 'background 0.2s, color 0.2s'
          }}
        >
          Try Genix Pendant
          <svg style={{ marginLeft: 8 }} width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="#0098d0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
      <div style={{ flex: 1, minWidth: 220, display: 'flex', justifyContent: 'flex-end' }}>
        <img
          src="/images/pendent.png"
          alt="Genix Pendant"
          style={{ width: 260, height: 200, objectFit: 'cover', borderRadius: 24 }}
        />
      </div>
    </div>
  </section>
);

export default ResourcesProductUpdate; 